// extracted by mini-css-extract-plugin
export default {"container":"Card_container__TNCmo","imageCard":"Card_imageCard__x6hwd"};